import { createContext, useContext, useEffect, useState } from "react";
import { LOCATIONS, DEFAULT_LOCATION_ID } from "../data/locations";

const STORAGE_KEY = "sh_selected_location";

const LocationContext = createContext(null);

export function LocationProvider({ children }) {
  const [locationId, setLocationId] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored && LOCATIONS[stored] ? stored : DEFAULT_LOCATION_ID;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, locationId);
  }, [locationId]);

  const value = {
    location: LOCATIONS[locationId],
    locationId,
    setLocationId,
  };

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
}

export function useSelectedLocation() {
  const ctx = useContext(LocationContext);
  if (!ctx) {
    throw new Error(
      "useSelectedLocation must be used within a LocationProvider"
    );
  }
  return ctx;
}
